import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchComparativePalletBoxUsage = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPalletBoxUsageComp',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchComparativePalletBoxUsage;
